import { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';
import { DefaultCarouselView, ReplaysPageLayoutOptions } from '../../../../../../../../../../api/custom-pages.dao';
import { defaultCarouselViewOptions } from '../../../default-pages.const';
import { DEFAULT_CAROUSEL_VIEW_INFO_MSG } from '../../../default-pages.texts';
import { REPLAYS_DEFAULT_CAROUSEL_VIEW, REPLAYS_LAYOUT } from '../../../../../../../../../../modules/passport-pages/config';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';

export const useReplaysLayout = (pageVm: DefaultPageViewModel) => {
    const { formatMessage } = useIntl();

    const replaysLayout = pageVm.getFieldByKey(REPLAYS_LAYOUT);
    const layoutLabel = formatMessage(pageVm.getFieldConfigByKey(REPLAYS_LAYOUT).labelDescriptor);
    const isGridViewByTrackSelected = replaysLayout.value === ReplaysPageLayoutOptions.GridViewByTrack;

    const replaysDefaultCarouselView = pageVm.getFieldByKey(REPLAYS_DEFAULT_CAROUSEL_VIEW);
    const carouselViewLabel = formatMessage(pageVm.getFieldConfigByKey(REPLAYS_DEFAULT_CAROUSEL_VIEW).labelDescriptor);
    const carouselViewInfoMessage = formatMessage(DEFAULT_CAROUSEL_VIEW_INFO_MSG);

    const handleReplaysLayoutChange = (e: ChangeEvent<HTMLSelectElement>) => {
        pageVm.setFieldValueByKey(REPLAYS_LAYOUT, e.target.value);
        if (e.target.value !== ReplaysPageLayoutOptions.GridViewByTrack) {
            pageVm.setFieldValueByKey(REPLAYS_DEFAULT_CAROUSEL_VIEW, DefaultCarouselView.ShowAll);
        }
    };
    const handleCarouselViewChange = (e: ChangeEvent<HTMLSelectElement>) =>
        pageVm.setFieldValueByKey(REPLAYS_DEFAULT_CAROUSEL_VIEW, e.target.value);

    return {
        layoutLabel: layoutLabel,
        replaysLayout: replaysLayout,
        isGridViewByTrackSelected: isGridViewByTrackSelected,
        carouselViewLabel: carouselViewLabel,
        carouselViewInfoMessage: carouselViewInfoMessage,
        replaysDefaultCarouselView: replaysDefaultCarouselView,
        carouselViewOptions: defaultCarouselViewOptions,
        handleReplaysLayoutChange: handleReplaysLayoutChange,
        handleCarouselViewChange: handleCarouselViewChange,
    };
};